import { render, staticRenderFns } from "./DashboardFiltersPopover.vue?vue&type=template&id=227839af&scoped=true"
import script from "./DashboardFiltersPopover.vue?vue&type=script&lang=js"
export * from "./DashboardFiltersPopover.vue?vue&type=script&lang=js"
import style0 from "./DashboardFiltersPopover.vue?vue&type=style&index=0&id=227839af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227839af",
  null
  
)

export default component.exports